import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  standalone: false,
  selector: 'sbnb-connect-done',
  templateUrl: './connect-done.component.html',
  styleUrls: ['./connect-done.component.scss'],
})
export class ConnectDoneComponent implements OnInit {
  @Input() platform: 'agoda' | 'homeaway' | 'booking';

  constructor(private readonly route: ActivatedRoute) { }

  ngOnInit(): void {
  }
}
